/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
// import Vue from 'vue';
import axios from 'axios';
// import qs from 'qs';
// import Cookies from 'js-cookie';
const base = '';
const service = axios.create({
    timeout: 50000,
});
// console.log(Cookies.get('ttl'))
// 请求拦截 req 数据处理
service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        console.log('axios请求报错:', error);
    }
);

// res 数据处理
service.interceptors.response.use(
    response => {
        if (response.data.code == 22002) {
            // Cookies.remove('ttl', { expires: 1, path: '/' });
            // Cookies.remove('userinfo', { expires: 1, path: '/' });
            // localStorage.removeItem('hisnotice');
            // window.location.href = `${window.loginurl}?ttlurl=${window.location.protocol}//${window.location.host}`;
        };


        return Promise.resolve(response.data);
    },
    error => {
        return Promise.reject(error.response);
    }
);
// 根据文章ID 获取文章详情
const getServerTime = params => {
    return axios.get(`${base}/api/article/detail`, { params });
};
// 获取文章分类列表
const getCategoryList = params => {
    return axios.get(`${base}/api/category/list`, { params });
};
// 获取分类中的热门文章列表
const getHotList = params => {
    return axios.get(`${base}/api/article/hot/list`, { params });
};
// 根据分类获取文章列表
const getArticleList = params => {
    return service.get(`${base}/api/article/list`, { params });
};
// 根据文章ID 获取文章详情
const getArticleDetail = params => {
    return service.get(`${base}/api/article/detail`, { params });
};
const getArticleOldDetail = params => {
    return service.get(`${base}/api/article/old/detail`, { params });
};
const getOldDetail = params => {
    return service.get(`${base}/api/article/old/detail`, { params });
};
// 搜索文章
const getArticleSearch = params => {
    return service.get(`${base}/api/article/search`, { params });
};


export {
    getServerTime,
    getCategoryList,
    getHotList,
    getOldDetail,
    getArticleList,
    getArticleDetail,
    getArticleSearch,
    getArticleOldDetail

};


// WEBPACK FOOTER //
// ./src/axios/index.js